import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconTrophy: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20 4H17V3C17 2.4 16.6 2 16 2H8C7.4 2 7 2.4 7 3V4H4C3.4 4 3 4.4 3 5V6C3 8.5 4.9 10.6 7.4 10.9C8 12.4 9.4 13.5 11 13.9V17H9C7.3 17 6 18.3 6 20V21C6 21.6 6.4 22 7 22H17C17.6 22 18 21.6 18 21V20C18 18.3 16.7 17 15 17H13V13.9C14.6 13.6 16 12.4 16.6 10.9C19.1 10.6 21 8.5 21 6V5C21 4.4 20.6 4 20 4ZM15 19C15.6 19 16 19.4 16 20H8C8 19.4 8.4 19 9 19H15ZM5 6H7V8.8C5.8 8.4 5 7.3 5 6ZM12 12C10.3 12 9 10.7 9 9V5V4H15V5V9C15 10.7 13.7 12 12 12ZM17 8.8V6H19C19 7.3 18.2 8.4 17 8.8Z',
    })
  )
}
